module.exports = __webpack_public_path__ + "static/media/Horni_hory.0067ce4e.md";